module.exports = "<div class=\"body\">\n  <audio src=\"../../../assets/sounds/GPS.wav\" controls class=\"audio\"></audio>\n</div>\n"